import { FormLabel } from '@/components/ui/form'

export interface LabelProps extends React.PropsWithChildren {}

const Component = ({ children }: LabelProps) => (
  <FormLabel>{children}</FormLabel>
)
Component.displayName = 'Label'

export { Component as Label }
